import type { HelpFile } from '../../types/help'
import { FilterPanelTestIds } from '../../../testids/FilterPanelTestIds'

export const filterPanelHelp: HelpFile = {
  docPage: '/docs/help-system/filters',
  texts: {
    [FilterPanelTestIds.filterPanel]:
      'Komplexe Filterbedingungen über die Spalten dieser Liste — jeder Chip schränkt das Ergebnis weiter ein.',
    [FilterPanelTestIds.filterPanelTitle]: null,
    [FilterPanelTestIds.btnFilterApply]:
      'Vorbereitete Filter anwenden und die Liste aktualisieren — aktive Filter erscheinen als Chips oberhalb der Tabelle.',
    [FilterPanelTestIds.btnFilterClearAll]:
      'Alle aktiven Filter zurücksetzen und die vollständige Liste wieder anzeigen.',
  },
}
